<template>
<PageShell>
  <h1 class="site-h1">GB WhatsApp Old Versions APK Download</h1>
  <p class="site-lead">Looking for an earlier GB WhatsApp release? Browse previous versions with detailed information including version numbers, release dates, APK sizes, and Android compatibility. Older versions can be useful for users who need better compatibility with specific devices or prefer previous releases.</p>

  <div style="margin: 30px 0;">
    <DownloadButton label="Download GB WhatsApp v18.80 APK (Latest)" />
  </div>

  <h2 class="site-h2">Download GB WhatsApp Previous Versions</h2>
  <p>Some users prefer older GB WhatsApp versions because newer updates may not work perfectly on certain devices.</p>
  <p>Older APK versions can be useful for:</p>
  <ul class="site-ul">
    <li>Older Android phones</li>
    <li>Compatibility testing</li>
    <li>Restoring previous features</li>
    <li>Avoiding unexpected update changes</li>
  </ul>

  <div class="site-old-versions">
    <article v-for="item in oldVersions" :key="item.version" class="site-old-version-card">
      <img src="@/assets/whatsapp-icon.png" alt="GB WhatsApp Old Version">
      <div class="site-old-version-content">
        <div class="site-h3-style" style="margin-top:0">GB WhatsApp {{ item.version }}</div>
        <ul>
          <li><strong>Version:</strong> {{ item.versionNumber }}</li>
          <li><strong>Release Date:</strong> {{ item.date }}</li>
          <li><strong>File Size:</strong> {{ item.size }}</li>
          <li><strong>Required OS:</strong> Android 5.0+</li>
          <li><strong>Status:</strong> {{ item.status }}</li>
          <li v-if="item.extra">{{ item.extra }}</li>
        </ul>
        <a :href="site.apkUrl" class="site-old-version-dl">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 6px;"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
          Download Now
        </a>
      </div>
    </article>
  </div>

  <h2 class="site-h2">GB WhatsApp Version History</h2>
  <table class="site-table">
    <thead>
      <tr>
        <th>Version</th>
        <th>Updated</th>
        <th>Android</th>
        <th>Size</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in versionHistory" :key="row.version">
        <td><strong>{{ row.version }}</strong></td>
        <td>{{ row.updated }}</td>
        <td>{{ row.android }}</td>
        <td>{{ row.size }}</td>
        <td>{{ row.status }}</td>
      </tr>
    </tbody>
  </table>

  <h2 class="site-h2">Why Download an Older GB WhatsApp Version?</h2>
  <p>There are several reasons users choose previous releases:</p>
  
  <div class="site-h3-style">Device Compatibility</div>
  <p>Older phones may perform better with previous versions.</p>
  
  <div class="site-h3-style">Feature Preference</div>
  <p>Some users prefer older interfaces or specific features.</p>
  
  <div class="site-h3-style">Update Issues</div>
  <p>If a new update causes bugs, installing a previous version may temporarily solve compatibility problems.</p>

  <h2 class="site-h2">How to Install an Old GB WhatsApp APK</h2>
  <p>Before installing an older version:</p>
  <ol class="site-timeline">
    <li>Backup your WhatsApp chats.</li>
    <li>Remove the current version if necessary.</li>
    <li>Enable unknown app installation.</li>
    <li>Install the older APK file.</li>
    <li>Verify your phone number.</li>
  </ol>

  <h2 class="site-h2">Should You Use an Older Version?</h2>
  <p>Older versions may not include the latest improvements and security updates.</p>
  <p>For the best experience, we recommend using the <router-link to="/">latest GB WhatsApp</router-link> release whenever your device supports it.</p>
  <p>Older versions are mainly provided for compatibility and reference purposes.</p>

  <h2 class="site-h2">GB WhatsApp Old Versions FAQ</h2>
  <div class="site-faq">
    <details class="site-faq-item" open>
      <summary>Can I downgrade GB WhatsApp?</summary>
      <div class="site-faq-content">
        <p>Yes, but you should back up your chats before installing an older APK.</p>
      </div>
    </details>
    <details class="site-faq-item">
      <summary>Which GB WhatsApp version is best?</summary>
      <div class="site-faq-content">
        <p>The latest stable version is usually recommended for most users.</p>
      </div>
    </details>
    <details class="site-faq-item">
      <summary>Do old versions work on Android 15?</summary>
      <div class="site-faq-content">
        <p>Compatibility depends on the specific version and device.</p>
      </div>
    </details>
  </div>
</PageShell>
</template>

<script>
import PageShell from '@/components/PageShell.vue'
import DownloadButton from '@/components/DownloadButton.vue'
import { OLD_VERSIONS, SITE } from '@/constants/site'

export default {
  name: 'OldVersions',
  components: { PageShell, DownloadButton },
  data() {
    return {
      site: SITE,
      versionHistory: OLD_VERSIONS,
      oldVersions: [
        { version: 'v18.80', versionNumber: '18.80', date: 'May 2026', size: '95.0 MB', status: 'Latest / Recommended', extra: 'Mobile app reviews' },
        { version: 'v18.74', versionNumber: '18.75', date: 'March 2026', size: '84 MB', status: 'Stable' },
        { version: 'v18.70', versionNumber: '18.70', date: 'March 2026', size: '84 MB', status: 'Stable' },
        { version: 'v18.65', versionNumber: '18.65', date: 'February 2026', size: '83 MB', status: 'Stable', extra: 'Communications & Media Studies' },
        { version: 'v18.60', versionNumber: '18.60', date: 'February 2026', size: '83 MB', status: 'Stable' },
        { version: 'v16.50', versionNumber: '18.55', date: 'January 2025', size: '82 MB', status: 'Stable' },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.site-old-versions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 30px 0;
}

.site-old-version-card {
  display: flex;
  gap: 24px;
  background: #fff;
  border: 1px solid var(--site-border);
  border-radius: 12px;
  padding: 24px;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

  img {
    width: 84px;
    height: 84px;
    border-radius: 18px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .site-old-version-content {
    flex: 1;
    min-width: 0;

    .site-h3-style {
      margin: 0 0 12px;
      font-size: 18px;
      color: var(--site-green-dark);
      font-weight: 700;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0 0 16px;
      display: flex;
      flex-wrap: wrap;
      gap: 12px 24px;

      li {
        font-size: 13px;
        color: var(--site-muted);
        display: flex;
        align-items: center;
        gap: 6px;

        strong {
          color: var(--site-text);
          font-weight: 600;
        }
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    img {
      width: 72px;
      height: 72px;
    }
  }
}

.site-old-version-dl {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--site-accent);
  color: #fff !important;
  font-weight: 600;
  text-decoration: none !important;
  padding: 10px 24px;
  border-radius: 999px;
  font-size: 14px;
  transition: background 0.2s ease, transform 0.2s ease;
  box-shadow: 0 4px 10px rgba(37, 211, 102, 0.2);
}

.site-old-version-dl:hover {
  background: var(--site-accent-dark);
  transform: translateY(-1px);
}
</style>